import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=1d0ab6d8&scoped=true"
import script from "./IntroPage.vue?vue&type=script&lang=js"
export * from "./IntroPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ab6d8",
  null
  
)

export default component.exports